import { isAxiosError } from "axios";

// True when the API refused the request outright. Callers use this to tell a
// permissions denial (which a retry can never fix, and which must never be
// rendered as a zero) apart from a transient failure.
export function isForbiddenError(error: unknown): boolean {
  return isAxiosError(error) && error.response?.status === 403;
}

export function unpackRequestErrorMessage(error: unknown): string {
  if (isAxiosError(error)) {
    if (
      error.response?.data &&
      typeof error.response.data === "object" &&
      "error_message" in error.response.data
    ) {
      return error.response.data.error_message as string; // Here's an assumption for ya
    }

    if (error.message) {
      return error.message;
    }
  }

  if (error instanceof Error) {
    return error.message;
  }

  return "An unknown error occurred.";
}
